<template>
    <div class="kit mb-5">
        <KitHeader
        :title="$root.t('Kits de acessórios')"
        :subtitle="$root.t('Treine Em Casa com a Smart Fit!')"
        :description="$root.t('Reunimos os nossos parceiros para que você treine com o que há de melhor no mercado fitness. Compre direto do fornecedor, tenha descontos exclusivos e receba em casa.')"></KitHeader>

        <div class="container mt-4">
            <div class="row">
                <div class="col-md-12 mb-3">
                    <h2 class="kit__title" v-html="activeKit.title"></h2>
                    <p class="kit__description" v-html="activeKit.description"></p>
                </div>

                <div class="col-md-7 mb-4">
                    <Gallery v-if="images.length" :images="images"></Gallery>
                </div>

                <div class="col-md-5 mb-4">
                    <div class="kit__price">
                        <small v-html="activeKit.payment_type"></small>
                        <h3 class="mb-0" v-html="activeKit.payment_price"></h3>
                        <small v-html="activeKit.payment_subprice"></small>

                        <a :href="activeKit.link" target="_blank" class="btn btn-lg">
                            {{ $root.t('Ir à loja') }}
                        </a>
                    </div>
                </div>

                <div class="col-md-12">
                    <div class="kit__content" v-html="activeKit.content"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import KitHeader from '@/components/KitHeader'
import Gallery from '@/components/Gallery'

export default {
    components : { KitHeader, Gallery },
     data () {
        return {
            slug : this.$route.params.id,
            category : this.$route.params.category,
            images : []
        }
    },
    computed : {
        ...mapGetters([
            'activeKit',
            'kits'
        ])
    },
    watch : {
        kits () {
            this.setActiveKit({ category : this.category, slug : this.slug })
        },
        activeKit () {
            this.images = Object.keys(this.activeKit.gallery).map( k => this.activeKit.gallery[k] )
        }
    },
    methods : {
        ...mapActions({
            setActiveKit : 'setActiveKit',
            getKits : 'getKits'
        })
    },
    created () {
        this.getKits();
        this.setActiveKit(this.slug)
    }
    
}
</script>

<style lang="scss">
    @import "@/assets/scss/settings/_variables.scss";
    @import "@/assets/scss/settings/_mixins.scss";

    .kit {
        &__title {
            margin-bottom: 0;
            font-weight: 400;
        }

        &__description {
            opacity: 0.7;
            margin-top: 0;
        }

        &__price {
            text-align: center;
            border-radius: 10px;
            border: 1px solid $c_highlight;
            padding: 20px;
            display: flex;
            flex-direction: column;
            align-items: center;

            small { 
                font-size: 16px;
                color: #999;
            }

            a {
                margin-top: 15px;
            }
        }

        &__content {
             h1,h2,h3,h4 {
                position: relative;

                &:after{
                    content: '';
                    position: absolute;
                    height: 5px;
                    width: 64px;
                    background: #FFB612;
                    left: 0;
                    bottom: -7px;
                }
            }
        }
    }
</style>